import { Node as ProseMirrorNode } from 'prosemirror-model';

import { createContext } from '@lyearn/core/utils/context';

const PROSE_MIRROR_CONTEXT_PROVIDER = 'PROSE_MIRROR_CONTEXT_PROVIDER';
type ProsMirrorNodeProviderProps = {
  node?: ProseMirrorNode;
};

const [ProseMirrorNodeProvider, useProseMirrorContext] = createContext<ProsMirrorNodeProviderProps>(
  PROSE_MIRROR_CONTEXT_PROVIDER,
);

const useProsMirrorNode = () => {
  const context = useProseMirrorContext();
  if (!context) {
    return {};
  }
  return context;
};

export { ProseMirrorNodeProvider, useProsMirrorNode };
